import { useEffect, useState } from "react";
import TestListModel from "../../services/models/testList.model";
import CustomAccordion from "../organism/CustomAccordion";
import SelectTestCard from "./SelectTestCard";
import SelectTestCardProps from "../../services/models/selectTestCardProps.model";
import OnlineOrderActions from "../../services/OnlineOrderActions";
import usePublicTestsList from "../../services/utils/custom hooks/SignUp/usePublicTestLists";
import SelectTestLoadingIndicator from "./LoadingIndicators/OnlineOrder/SelectTestLoadingIndicator";
import TestAccordingLoadingIndicator from "./LoadingIndicators/OnlineOrder/TestAccordionLoadingIndicator";
type testCodeType = { label: string; id: number[]; value: string };
const testCodes: testCodeType[] = [
  {
    label: "SCC",
    id: [2],
    value: "SCC",
  },
  {
    label: "CM",
    id: [3, 6],
    value: "CM",
  },
  {
    label: "UM",
    id: [4, 7],
    value: "UM",
  },
  {
    label: "TC",
    id: [1],
    value: "TC",
  },
  {
    label: "DDM",
    id: [5],
    value: "DDM",
  },
  {
    label: "IDG",
    id: [8],
    value: "IDG",
  },
  {
    label: "AD",
    id: [9],
    value: "AD",
  },
];

function SignUpTestSelectionStep({
  setFieldValue,
  setFieldTouched,
  values,
}: {
  setFieldValue: any;
  setFieldTouched: any;
  values: any;
}): JSX.Element {
  const { data, isLoading } = usePublicTestsList();
  const [testsList, setTestList] = useState<TestListModel[]>([]);
  const [selectedTests, setSelectedTests] = useState<number[]>([]);
  const [activeIndex, setActiveIndex] = useState<any>(null);
  const handleQuestionClick = (index: any) => {
    return () => setActiveIndex(activeIndex === index ? null : index);
  };

  function handleSelection(test: SelectTestCardProps) {
    let temp = [...selectedTests];
    let selectedTestCodes: string[] = [];

    setFieldTouched("org.cbsTests", true);
    if (temp.includes(test.id)) {
      temp = temp.filter((testId) => testId !== test.id);
      setSelectedTests(temp);
    } else {
      temp.push(test.id);
      setSelectedTests(temp);
    }

    testCodes.forEach((testCode) => {
      let idFound = testCode.id.some((id) => temp.includes(id));
      if (idFound) selectedTestCodes.push(testCode.value);
    });

    setFieldValue(`org.cbsTests`, selectedTestCodes);
  }

  const onlineOrderActions = new OnlineOrderActions(null, null, null, [], "");

  useEffect(() => {
    if (data && data?.data?.length > 0) {
      setTestList(onlineOrderActions.getTestList(data, activeIndex));
    }
  }, [isLoading]);

  if (isLoading) {
    return <TestAccordingLoadingIndicator />;
  }

  return (
    <div>
      {testsList.map((testSection, index) => (
        <CustomAccordion
          key={testSection.title}
          index={index}
          activeIndex={activeIndex}
          handleQuestionClick={handleQuestionClick?.(index)}
          title={testSection.title}
          allExpanded={false}
        >
          <div className="flex flex-wrap">
            {testSection.tests.map((test, testIndex) => {
              return (
                <SelectTestCard
                  key={test.id + test.testName}
                  hideFavIcon
                  {...test}
                  className="mb-2"
                  selected={selectedTests.includes(test.id)}
                  // selected={values.org.cbsTests.includes(
                  //   testCodes.find((code) => code.id.includes(test.id))?.value
                  // )}
                  handleSelection={() => handleSelection(test)}
                />
              );
            })}
          </div>
        </CustomAccordion>
      ))}
    </div>
  );
}

export default SignUpTestSelectionStep;
